import moment from 'moment-timezone'
import { capitalize } from '../../decorators/textTools'
import type { ConversationApiData, ConversationDisplayData } from './types'

const DEFAULT_TIMEZONE = 'America/New_York'

export function enrichConversation(raw: ConversationApiData): ConversationDisplayData {
  const tz = raw.timezone || DEFAULT_TIMEZONE
  const locale = raw.locale || 'en_US'
  const m = moment(raw.startsAt).locale(locale).tz(tz)

  return {
    ...raw,
    startsAtLocally: m.format('LT'),
    dateLocally: capitalize(m.format('LL')),
    dayLocally: m.format('ddd'),
    timeZoneAbbr: moment().tz(tz).format('zz'),
    isVirtual: raw.venueType === 'virtual',
  }
}

export function enrichConversations(items: ConversationApiData[]): ConversationDisplayData[] {
  return items.map(enrichConversation)
}
